import SolutionLayout from "@/pages/solutions/components/SolutionLayout";

const features = [
  {
    title: "White-label rate decks",
    desc: "Export custom rate decks under your own branding. Set your own margins and sell to your end customers at the price you choose.",
    icon: "ri-file-copy-line",
  },
  {
    title: "Margin-friendly pricing",
    desc: "Our wholesale rates are designed to leave healthy room for resale. Many resellers operate at 40-70% markup while still undercutting retail carriers.",
    icon: "ri-price-tag-3-line",
  },
  {
    title: "Co-branded portal",
    desc: "Give your customers a white-labeled portal to view balances, download CDRs, and request DID numbers — all under your brand.",
    icon: "ri-window-2-line",
  },
  {
    title: "Volume incentives",
    desc: "Aggregated reseller volumes count toward your tiered pricing. The more your customers grow, the better your own rates become.",
    icon: "ri-bar-chart-grouped-line",
  },
];

const stats = [
  { value: "100%", label: "Your brand, your customers" },
  { value: "160+", label: "Countries for resale" },
  { value: "4", label: "White-label portal themes" },
  { value: "24h", label: "Reseller onboarding SLA" },
];

export default function Resellers() {
  return (
    <SolutionLayout
      title="Solutions for Resellers"
      tagline="Launch a VoIP resale business under your own brand — we handle the routes, you keep the customer relationship and the margin."
      badge="White-label · For Resellers"
      breadcrumbLabel="For Resellers"
    >
      <section className="pb-10 md:pb-14">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {stats.map((s) => (
              <div key={s.label} className="rounded-xl border border-background-200 bg-background-50 p-5 text-center">
                <div className="text-2xl md:text-3xl font-semibold font-heading text-foreground-950">{s.value}</div>
                <div className="text-xs md:text-sm text-foreground-600 mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-100/60 border-y border-background-200">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="mb-10">
            <span className="text-xs uppercase tracking-widest text-primary-600 font-semibold">Reseller platform</span>
            <h2 className="mt-3 text-3xl md:text-4xl font-semibold text-foreground-950 leading-tight">
              Your brand. Our routes. Your margin.
            </h2>
            <p className="mt-3 text-foreground-700 max-w-2xl">
              Everything you need to launch, grow, and scale a wholesale resale operation — without investing in your own carrier infrastructure.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {features.map((f) => (
              <div key={f.title} className="rounded-xl border border-background-200 bg-background-50 p-6 hover:border-accent-400 transition-colors">
                <span className="w-11 h-11 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center">
                  <i className={`${f.icon} text-xl w-6 h-6 flex items-center justify-center`} />
                </span>
                <h3 className="mt-4 text-base font-semibold text-foreground-950 font-heading">{f.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </SolutionLayout>
  );
}